import { useEffect, useState } from 'react';
import { gapi } from 'gapi-script';
import "../css/Calendar.css"
import { NavLink } from "react-router-dom";

const API_KEY = 'AIzaSyDdYH6IfPKS50tqsEjTbHE3tZeX39Y_Zpw';
const CALENDAR_ID = '775ed54b85a51344717f80d80630a2702e10a8369106839f27259c1171625b22@group.calendar.google.com';
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];

export const Calendar = () => {
  const [events, setEvents] = useState([]);
  const [currentWeek, setCurrentWeek] = useState(new Date());

  useEffect(() => {
    const listUpcomingEvents = () => {
      const oneWeekLater = new Date(currentWeek);
      oneWeekLater.setDate(oneWeekLater.getDate() + 7);
  
      gapi.client.calendar.events.list({
        calendarId: CALENDAR_ID,
        timeMin: currentWeek.toISOString(),
        timeMax: oneWeekLater.toISOString(),
        showDeleted: false,
        singleEvents: true,
        orderBy: 'startTime',
      }).then(response => {
        const events = response.result.items;
        setEvents(events);
      }).catch(error => {
        console.error('Error fetching events:', error);
      });
    };
  
    function start() {
      gapi.client.init({
        apiKey: API_KEY,
        discoveryDocs: DISCOVERY_DOCS,
      }).then(() => {
        listUpcomingEvents();
      }).catch(error => {
        console.error('Error loading GAPI client:', error);
      });
    }
  
    gapi.load('client', start);
  }, [currentWeek]);

  const getWeekDates = (date) => {
    const week = [];
    for (let i = 0; i < 10; i++) {
      const day = new Date(date);
      day.setDate(date.getDate() + i);
      week.push(day);
    }
    return week;
  };

  const weekDates = getWeekDates(currentWeek);

  const changeWeek = (direction) => {
    const newDate = new Date(currentWeek);
    newDate.setDate(currentWeek.getDate() + direction * 7);
    setCurrentWeek(newDate);
  };

  const getEventForDate = (date) => {
    return events.find(event => {
      const eventDate = new Date(event.start.dateTime || event.start.date);
      return eventDate.toDateString() === date.toDateString();
    });
  };

  return (
    <div className="schedule-container">
      <h2>予約状況</h2>
      <div className="schedule-header">
        <button className="nav-button" onClick={() => changeWeek(-1)}>←</button>
        <h3 className="schedule-title">
          {weekDates[0].toLocaleDateString('ja-JP', { month: 'long', day: 'numeric' })} -
          {weekDates[6].toLocaleDateString('ja-JP', { month: 'long', day: 'numeric' })}
        </h3>
        <button className="nav-button" onClick={() => changeWeek(1)}>→</button>
      </div>
      {weekDates.map((date, index) => {
        const event = getEventForDate(date);
        return (
          <div key={index} className="date-card">
            <div className="date-card-content">
              <div className="date-circle">
                <span className="date-number">{date.getDate()}</span>
              </div>
              <div className="date-info">
                <div className="day-of-week">
                  {['日', '月', '火', '水', '木', '金', '土'][date.getDay()]}曜日
                </div>
                <div className="full-date">
                  {date.toLocaleDateString('ja-JP', { month: 'long', day: 'numeric' })}
                </div>
              </div>
              <div className="event-title">
                {event ? event.summary : '予定なし'}
              </div>
            </div>
          </div>
        );
      })}
      <p style={{ textAlign: "right" }}>
        <NavLink
          style={{
            fontSize: "20px",
            textDecoration: "underline"
          }}
          activeClassName="active"
          exact
          to="/Reserve"
        >
          &gt;&gt;一覧はこちら
        </NavLink>
      </p>
    </div>
  );
}